export const SITE = {
  name: "Lunar Ambitions",
  city: "Orlando, FL",
  phone: "(407) 538-9402",
  phoneHref: "tel:+14075389402",
  bookingGeneral:
    "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services",
  bookingConsultation:
    "https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services/IQYSSCFWXQGSIS64FCPZQOOO",
  giftOrder: "https://app.squareup.com/gift/ML1JMKJBA7K52/order",
  giftBalance: "https://app.squareup.com/gift/ML1JMKJBA7K52/check-balance",
  instagram: "https://www.instagram.com/lunarambitions/",
  facebook: "https://www.facebook.com/LunarAmbitions",
  logo: "/images/lunar-ambitions-logo.png",
};

export const FOOTER_LINKS = {
  studio: [
    { label: "Booking Policy", href: "/booking-policy" },
    { label: "Cancellation Policy", href: "/cancellation-policy" },
    { label: "Location / Directions", href: "/location-and-directions" },
    { label: "FAQ", href: "/faq" },
    { label: "About", href: "/about" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms and Conditions", href: "/terms-and-conditions" },
  ],
  gifts: [
    { label: "Gift Cards", href: SITE.giftOrder, external: true },
    { label: "Gift Card - Check Balance", href: SITE.giftBalance, external: true },
  ],
};

export const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "FAQ", href: "/faq" },
];
